module.exports = __webpack_public_path__ + "static/media/bj.61d77237.svg";